__turbopack_context__.v({
  "actions": "actions-module-scss-module__PzcZ7G__actions",
  "button": "actions-module-scss-module__PzcZ7G__button",
  "icon": "actions-module-scss-module__PzcZ7G__icon",
});
